import { render, staticRenderFns } from "./CreateRegisterModal.vue?vue&type=template&id=be2f1c0c&scoped=true"
import script from "./CreateRegisterModal.vue?vue&type=script&lang=js"
export * from "./CreateRegisterModal.vue?vue&type=script&lang=js"
import style0 from "./CreateRegisterModal.vue?vue&type=style&index=0&id=be2f1c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2f1c0c",
  null
  
)

export default component.exports